// Date 2022-06-14 20:26:00

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emWorkflowListView from "@/components/em/EmWorkflow/ListView";
import emWorkflowTaskView from "@/components/em/EmWorkflow/TaskView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

            import partyBuildingTestEdit from "@/views/party-building/PartyBuildingTestEdit.vue";
            import partyBuildingTestList from "@/views/party-building/PartyBuildingTestList.vue";
const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
            {
            path: "/party-building/partyBuildingTestEdit",
            name: "partyBuildingTestEdit",
            component: partyBuildingTestEdit,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            },
            {
            path: "/party-building/partyBuildingTestList",
            name: "partyBuildingTestList",
            component: partyBuildingTestList,
            props: (route) => ({ prop_inline: route.query.inline }),
            meta: metaObject
            }
]